export const commonConfig = {
  coinName: "HBAR",
  coinNameX: "HBARX",
  blockExplorerURL: "https://hashscan.io/mainnet",
};
